import axios from 'axios'
import ActionsLogin from './LoginActions'

const urlApi = process.env.URL_API_BASE

const headers = () => {
  return {
    headers: {
      Authorization: 'Bearer ' + ActionsLogin.getToken()
    }
  }
}

const cadastrarParametro = ({ cd_parametro, valor, descricao, idc_status }) => {
  return axios.post(`${urlApi}/sistema-parametro`,
    {
      cd_parametro: cd_parametro,
      valor: valor,
      descricao: descricao,
      idc_status: idc_status,
      created_by: ActionsLogin.getUsuario().cd_usuario
    },
    headers()
  )
}

const alterarParametro = ({ id, valor, descricao, idc_status }) => {
  return axios.patch(`${urlApi}/sistema-parametro/${id}`,
    {
      valor: valor,
      descricao: descricao,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    headers()
  )
}

const listar = () => {
  return axios
    .get(`${urlApi}/sistema-parametro`, headers())
    .then((response) => response.data)
}

export const obter = id => {
  return axios
    .get(`${urlApi}/sistema-parametro/${id}`, headers())
    .then((response) => response.data)
}

const listarAtivos = () => {
  return axios
    .get(`${urlApi}/sistema-parametro/listar-ativos/1`, headers())
    .then((response) => response.data)
}

export const getParametro = id => {
  return axios
    .get(`${urlApi}/sistema-parametro/obter-por-id/${id}`)
    .then((response) => response.data)
}

export const getParametroByLista = params => {
  return axios
    .get(`${urlApi}/sistema-parametro/obter-por-ids/${params.join()}`)
    .then((response) => response.data)
}

export default {
  cadastrarParametro,
  alterarParametro,
  listar,
  obter,
  listarAtivos,
  getParametro,
  getParametroByLista
}



// WEBPACK FOOTER //
// ./src/actions/ParametrosSistemaActions.js